// extracted by mini-css-extract-plugin
export default {"root":"VCQPG","normal":"hWLfp","tier-link":"_1AP4h","tierLink":"_1AP4h"};